// extracted by mini-css-extract-plugin
export default {"root":"_2kU1S","brace":"_1SWps","left-brace":"_1o1by","leftBrace":"_1o1by","right-brace":"_1BpSF","rightBrace":"_1BpSF","core-symbol":"_5G3_u","coreSymbol":"_5G3_u"};